import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import { FlowModuleEvents } from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents,
    MultiSetsMulticampaignPromotionStates,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionInProgressState extends ModuleState<null, MultiSetsMulticampaignPromotionModule, MultiSetsMulticampaignPromotionModuleEvents> {
    
    protected checkPromotionExpirationCallback: (dt: number) => void = this.checkPromotionExpiration.bind(this);

    public onEnterState(): void {
        this.module.emitHideBetPanel();
        this.module.activateCounter();
        this.module.updateManager.addUpdateFunction(this.checkPromotionExpirationCallback);
    }

    public onLeaveState(): void {
        this.module.updateManager.removeUpdateFunction(this.checkPromotionExpirationCallback);
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(LogicEvents.BALANCE_UPDATED, this.update.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.update.bind(this));
        this.setEventHandler(FlowModuleEvents.FEATURE_STARTED, this.onFeatureStarted.bind(this));
    }

    protected subtractPromotion(): void {
        this.module.getPromotion().subtractPromotion();
        this.module.updateCounter();

        if (this.module.getPromotion().isLastPromotion()) {
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.LAST_PROMOTION);
        } else {
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.IN_PROGRESS_SPINNING);
        }
    }

    protected update(): void {
        this.module.updateCounter();

        if (this.module.shouldEndPromotion()) {
            this.emit('General.Promotion.DeactivateCounter');
            this.module.emitShowBetPanel();
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.END);
        }
    }

    protected checkPromotionExpiration(): void {
        if (this.module.shouldTerminatePromotion()) {
            this.module.updateManager.removeUpdateFunction(this.checkPromotionExpirationCallback);
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.TERMINATED);
        }
    }

    private onFeatureStarted(): void {
        this.module.gotoState(MultiSetsMulticampaignPromotionStates.IN_PROGRESS_SPINNING);
    }

    private onReelsSpinningStarted(): void {
        if (this.module.getPromotion().isNextPromotion()) {
            this.subtractPromotion();
        }
    }
}
